// assets/auto-gallery-section.js
document.addEventListener('DOMContentLoaded', function() {
  // Intersection Observer for scroll animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Animate heading first
        const heading = entry.target.querySelector('.auto-gallery-heading');
        if (heading) {
          heading.classList.add('animate');
        }

        // Then animate gallery wrapper
        const wrapper = entry.target.querySelector('.auto-gallery-wrapper');
        if (wrapper) {
          wrapper.classList.add('animate');
        }
        
        // Unobserve after animation triggers
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe ALL auto gallery sections
  const autoGallerySections = document.querySelectorAll('.auto-gallery-section');
  autoGallerySections.forEach(section => {
    observer.observe(section);
  });

  // Ensure smooth animation restart when page visibility changes
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      const tracks = document.querySelectorAll('.auto-gallery-track');
      tracks.forEach(track => {
        // Force animation restart
        track.style.animation = 'none';
        track.offsetHeight; // Trigger reflow
        track.style.animation = null;
      });
    }
  });
});